import giftGuidePageStateManager from './gift_guide_page_state_manager';
import loadable from '@loadable/component';

const GiftGuidePage = loadable(() => import('./gift_guide_page'));

export default function(store) {
  return {
    path: '/gift-guide/:slug/category/:category',
    component: GiftGuidePage,
    exact: true,
    strict: true,
    loadData: giftGuidePageStateManager(store),
    autoScrollOff: true
  };
}
